import { Flex } from "@chakra-ui/react";
import BaseLayout from "src/layouts/BaseLayout/BaseLayout";
import SettingsCell from "src/components/SettingsCell";

export default function SettingsPage() {
  return (
    <BaseLayout>
      <Flex justifyContent="center" m={5}>
        <SettingsCell />
      </Flex>
    </BaseLayout>
  )
}
